import { ui } from '!/skin'
import { Skeleton } from '@/ui/components/Skeleton'
import { useUnit } from 'effector-react'
import { entityPartnerProductGridModel } from '~/entities/partner-product/grid'

PartnerProgramGridPage.displayName = 'PartnerProgramGridPage'

export function PartnerProgramGridPage(): JSX.Element {
  const isContentLoading = useUnit(
    entityPartnerProductGridModel.$partnerProductGridLoading
  )

  return (
    <ui.PageWrapper>
      <Skeleton pageType='grid' isLoading={isContentLoading}>
        <ui.RenderSkin name='partnerProgramGrid' />
      </Skeleton>
    </ui.PageWrapper>
  )
}
